import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollToTop(): null {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash !== '') {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
